import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBannerImageBelow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 36.715 48.953",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Bilde_under_Banner",
		"data-name": "Bilde under_Banner",
		transform: "translate(-109.872 -3277.791)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union_9",
			"data-name": "Union 9",
			d: "M8693.081,22832.955a4.089,4.089,0,0,1-4.08-4.08v-40.793a4.089,4.089,0,0,1,4.08-4.08h28.555a4.089,4.089,0,0,1,4.08,4.08v40.793a4.089,4.089,0,0,1-4.08,4.08Zm-2.04-44.873v40.793a1.925,1.925,0,0,0,2.04,2.041h28.555a1.926,1.926,0,0,0,2.04-2.041v-40.793a1.926,1.926,0,0,0-2.04-2.041h-28.555A1.925,1.925,0,0,0,8691.041,22788.082Zm6.372,40.02a2.046,2.046,0,0,1-1.994-1.988v-19.895a2.05,2.05,0,0,1,1.994-1.99H8717.3a2.052,2.052,0,0,1,1.994,1.99v19.895a2.048,2.048,0,0,1-1.994,1.988Zm1.856-5.2h16.212l-4.871-6.5-4.378,5.668-3.083-4.213Zm-1.088-23.523v-2.039h18.354v2.039Zm0-6.119v-2.035h18.354v2.035Z",
			transform: "translate(-8579.129 -19506.211)"
		})
	})
});
export default SvgBannerImageBelow;
